<template>
  <div v-loading="authLoginLoading">
    <div class="title">快捷登录授权</div>
    <div class="info-box">
      <div class="info-label">微信登录</div>
      <div class="info-content">
        <el-switch
          :value="isAuth"
          active-color="#22c655"
          inactive-color="#dcdfe6"
          :active-value="true"
          :inactive-value="false"
          @change="switchChange"
        />
        <span class="info-content-text" :class="[isAuth ? 'info-content-active' : '']">
          {{ isAuth ? '已授权' : '未授权' }}
        </span>
      </div>
    </div>
  </div>
</template>

<script >
import store from '@/store';
import { computed, onMounted } from '@vue/composition-api';
import { MessageBox } from 'element-ui';
import { useAuthLogin } from '@/views/login/hooks/useAuthLogin.js';
const __sfc_main = {};
__sfc_main.setup = (__props, __ctx) => {
  const {
    authLoginLoading,
    getWxAuthUrl,
    handleUnBind,
    handleBind
  } = useAuthLogin({
    refreshRoute: '/user/profile'
  });
  const isAuth = computed(() => {
    const userInfo = store.state.user.userInfo || {};
    return userInfo.wechat;
  });
  const phone = computed(() => {
    const userInfo = store.state.user.userInfo || {};
    return userInfo.phone;
  });
  const switchChange = async val => {
    if (val) {
      // 获取跳转地址
      getWxAuthUrl();
      return;
    }
    // 解除绑定
    MessageBox.confirm(`账号【${phone.value}】已与微信关联，是否解除`, '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning'
    }).then(() => {
      handleUnBind();
    }).catch(() => {
      console.log('用户已取消');
    });
  };
  onMounted(() => {
    handleBind();
  });
  return {
    authLoginLoading,
    isAuth,
    switchChange
  };
};
export default __sfc_main;
</script>

<style lang="scss" scoped>
  .title {
    margin-bottom: 20px;
    font-size: 20px;
    font-weight: 700;
    color: #333333;
  }
  .info-box {
    margin-bottom: 30px;
    display: flex;
    align-items: center;
  }
  .info-label {
    width: 160px;
    font-size: 16px;
    font-weight: 400;
    color: #666666;
  }
  .info-content {
    width: 0;
    flex: 1;
    font-size: 14px;
    font-weight: 500;
    color: #333333;
    display: flex;
    align-items: center;
    &-text {
      margin-left: 15px;
      font-size: 14px;
      font-weight: 500;
      color: #333333;
    }
    &-active {
      color: #22c655;
    }
  }
</style>
